import {
    getOwnDetailsFailed,
    getOwnDetailsLoading,
    getOwnDetailsSuccess,
} from "@redux/slices/profileSlice"
import { getOwnDetails } from "@services/profile/getOwnDetails"
import { useCallback } from "react"
import { useDispatch } from "react-redux"

const useProfile = () => {
    const dispatch = useDispatch()
    const handleGetOwnDetails = useCallback(async () => {
        try {
            dispatch(getOwnDetailsLoading())
            const response = await getOwnDetails()
            dispatch(getOwnDetailsSuccess(response.data?.data))
        } catch (error) {
            dispatch(getOwnDetailsFailed())
            console.log(error)
        }
    }, [dispatch])
    return {
        handleGetOwnDetails,
    }
}

export default useProfile
